<template>
  <div class="password-container">
    <input
      aria-label="password"
      class="password-field"
      type="password"
      placeholder="Please Input Your Password"
      v-model="password"
    />
    <p class="wrong-password" v-if="passwordIncorrect">Wrong password. Try again.</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: null,
      passwordIncorrect: false,
    };
  },

  props: {
    modelValue: Boolean,
  },

  methods: {
    async confirmPassword() {
      const payload = { password: this.password };
      const { loginUser } = this.$store.getters;
      await this.$api
        .post(`/facilitators/${loginUser.id}/password-confirmation`, payload)
        .then((data) => {
          if (!data.success) {
            this.passwordIncorrect = true;
            this.$emit('update:modelValue', false);
            return;
          }

          this.$emit('confirmed');
        })
        .catch(() => {
          this.passwordIncorrect = true;
          this.$emit('update:modelValue', false);
        });
    },
  },

  watch: {
    modelValue() {
      this.confirmPassword();
    },
  },
};
</script>

<style scoped>
.password-container {
  position: relative;
  width: 100%;
  height: 4.5em;

  margin-bottom: 2.3em;
}
.password-field {
  font-size: 16px;
  width: calc(100% - 1em);
  height: 2.6em;
  padding-left: 1em;
  border: 1px solid #a7a9ac;
  border-radius: 5px;
}
.password-field::placeholder {
  font-style: italic;
}
.wrong-password {
  position: absolute;
  bottom: 0%;
  width: 100%;
  margin: 0;

  font-style: italic;
  color: #df0d0d;
}
</style>
